export class DicerConfigModel {

    /**
     * Math multiplier
     */
    math_multiplier: bigint = BigInt(1000000000);

    /**
     * Percentage divider
     */
    percentage_divider: bigint = BigInt(1000);

    /**
     * Payout percentage
     */
    payout_percentage: bigint = BigInt(970);

    /**
     * Roll min amount
     */
    roll_min_amount: bigint = BigInt(1000000000);

    /**
     * Roll max amount
     */
    roll_max_amount: bigint = BigInt(1000000000000);
}